import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { buildQueryParams } from 'utils/helpers/queryParams'
import {
  InventoryAttributeItemInterface,
  InventoryAttributePaginationType,
} from '../@types/OutboundSKUConfig'

export type GetInventoryAttributesParamsType = {
  page_size: number
  page_index: number
  location_ids?: string
  product_ids?: string
}

export type GetInventoryAttributesResponseType = {
  data: InventoryAttributeItemInterface[]
  pagination: InventoryAttributePaginationType
}

export type PostInventoryAttributePayloadType = {
  product_id: number
  location_id: number
  is_hybrid_pooling: boolean
  distribute: boolean
}

export type PatchInventoryAttributePayloadType = PostInventoryAttributePayloadType

export const getInventoryAttributes = (params: Partial<GetInventoryAttributesParamsType>) =>
  axiosInstanceApiGateway.Get<GetInventoryAttributesResponseType, true>({
    url: '/wims/internal/v1/inventory-attributes',
    params,
    config: {
      paramsSerializer: {
        serialize: (p) => buildQueryParams(p).toString(),
      },
    },
  })

export const postInventoryAttribute = (data: PostInventoryAttributePayloadType) =>
  axiosInstanceApiGateway.Post({
    url: '/wims/internal/v1/inventory-attributes',
    data,
  })

export const patchInventoryAttribute = (
  productId: number,
  locationId: number,
  data: PatchInventoryAttributePayloadType,
) =>
  axiosInstanceApiGateway.Patch<{ message: string }, true>({
    url: `/wims/internal/v1/inventory-attributes/${productId}/${locationId}`,
    data,
  })
